import React from 'react';
import { Toggle, Tooltip, Whisper } from 'rsuite';
import infoIcon from '../../../../../../assets/icons/icon_info_gray.svg';
import styles from './CanalFilter.module.scss';
import { CANAL_TOOLTIP } from '../../data';

type CanalFilterProps = {
  checkedFisico: boolean;
  checkedDigital: boolean;
  onChange: (checked: boolean, canal: 'Canal físico' | 'Canal digital') => void;
};

export const CanalFilter = ({ checkedFisico, checkedDigital, onChange }: CanalFilterProps) => {
  return (
    <div className={styles['channel-type-container']}>
      <span className={styles['toggle-title']}>CANAL</span>
      <div className={styles['toggle-container']}>
        <div className={styles['channel-selling-point']}>
          <Toggle
            size="sm"
            checked={checkedFisico}
            id="channel-selling-point-toggle"
            onChange={e => onChange(e, 'Canal físico')}
            style={{ marginRight: '5px' }}
          />
          <span>Canal físico</span>
          <span className={styles['toggle-info-icon']}>
            <Whisper placement="bottom" trigger="hover" speaker={<Tooltip>{CANAL_TOOLTIP.FISICO}</Tooltip>}>
              <img src={infoIcon} alt="" />
            </Whisper>
          </span>
        </div>
        <div className={styles['channel-app']}>
          <Toggle size="sm" checked={checkedDigital} id="channel-app-toggle" onChange={e => onChange(e, 'Canal digital')} style={{ marginRight: '5px' }} />
          <span>Canal digital</span>
          <span className={styles['toggle-info-icon']}>
            <Whisper placement="bottom" trigger="hover" speaker={<Tooltip>{CANAL_TOOLTIP.DIGITAL}</Tooltip>}>
              <img src={infoIcon} alt="" />
            </Whisper>
          </span>
        </div>
      </div>
    </div>
  );
};
